// The items from Amazon for a building's blockers, each on the card for its own step
// (docs/Y2026-Q4/design-amazon-blocker-site-record.md).
import type { AmazonBuilding, AmazonNeed } from "../../api/hooks/useAmazonOverview";
import { onCard, stillNeeded } from "./needs";

/** Amazon design inputs has no items of its own: it counts those of the steps waiting on it. */
const INPUTS = "inputs";

/** The card an item from Amazon sits on: Amazon design inputs while that is a card, for a
 * design input, else the card that is its own step. */
export const homeOf = (n: AmazonNeed, inputsIsCard: boolean): string =>
  n.design_input && inputsIsCard ? INPUTS : n.step;

export interface BlockerItems {
  /** Each blocker's items, keyed by its step id. */
  byBlocker: Map<string, AmazonNeed[]>;
  /** Items still needed for a step with no card of its own. */
  elsewhere: AmazonNeed[];
}

/** Each item from Amazon on the card for its own step only (Noaa, 18 Oct), never on one
 * for an earlier step: a design input under Amazon design inputs while that is a
 * blocker, else the card that is its step. A card lists received items beside missing
 * ones; a still-needed item with no card is listed after the cards. Amazon's follow-up
 * with the landlord is listed here as one of Landlord feedback's items, and nowhere else
 * on Step 3 (Noaa, 21 Oct 2026). */
export const blockerItems = (b: AmazonBuilding, blockerIds: string[]): BlockerItems => {
  const byBlocker = new Map<string, AmazonNeed[]>(blockerIds.map((id) => [id, []]));
  const elsewhere: AmazonNeed[] = [];
  const items = [...(b.needs ?? []), ...(b.landlord_follow_up ? [b.landlord_follow_up] : [])];
  for (const n of items.filter((x) => onCard(b, x))) {
    const card = byBlocker.get(homeOf(n, byBlocker.has(INPUTS)));
    if (card) card.push(n);
    else if (stillNeeded(b, n)) elsewhere.push(n);
  }
  return { byBlocker, elsewhere };
};
